export default "<span class=\"alert errorDiv\" role=\"alert\" *ngIf=\"mostrarErro\">\r\n  <i class=\"icofont-warning-alt\"></i>{{ msgErro }}\r\n</span>\r\n"